import makeStyles from '@mui/styles/makeStyles';
import { FontFamilySwitch } from '../../utils';
export const AmenitiesMappingStyles = makeStyles((theme) => ({
    root: {
        border: "2px solid white",
        borderRadius: theme.palette.borderRadius,
        boxShadow: "0px 0px 16px #00000014",
        backgroundColor: "white",
        padding: "16px",
        height: `calc(100vh - 147px)`,
        overflow: "hidden",
        margin: "14px"
    },
    content: {
        textAlign: "center"
    },
    btn: {
        borderRadius: theme.palette.borderRadius,
        boxShadow: "none",
        fontSize:"0.875rem"
    },
    btn2: {
        borderRadius: theme.palette.borderRadius,
        color: theme.palette.secondary.main,
    },
    text: {
        fontSize:"1.5rem",
        fontFamily: FontFamilySwitch().bold,
        color: theme.typography.color.primary
    },
    drawer: {
        "& .MuiDrawer-paper": {
            borderTopLeftRadius: "16px",
            borderTopRightRadius: "16px",
        },
        "& .MuiContainer-root": {
            padding: "0px"
        },
    },
    dialog: {
        "& .MuiDialog-paper": {
            borderRadius: "16px",
            padding: "0px",
        },
    },
    drawerHeaderStyle: {
        justifyContent: "space-between",
        alignItems: "center",
        padding: "16px",
    },
    drawerHeaderTextStyle: {
        fontSize:"1rem",
        fontWeight: "bolder",
        color: theme.typography.color.primary,
    },
    subText: {
        fontSize:"1rem",
        fontFamily: FontFamilySwitch().semiBold,
        color: theme.typography.color.secondary
    },
    img: {
        border: `1px solid ${theme.palette.border.secondary}`,
        borderRadius: theme.palette.borderRadius,
        //marginTop: "4px",
        padding: "12px"
    },
    tableHead: {
        backgroundColor: "#F2F4F7",
        color: theme.typography.color.secondary,
        borderRadius: theme.palette.borderRadius,
        fontSize:"0.75rem",
        fontFamily: FontFamilySwitch().semiBold,
    },
    thead: {
        backgroundColor: '#F2F4F7',
        '& th:first-child': {
            borderRadius: '1em 0 0 1em'
        },
        '& th:last-child': {
            borderRadius: '0 1em 1em 0'
        }
    },
    tbody: {
        backgroundColor: '#F2F4F7',
        '& th:first-child': {
            borderRadius: '1em 0 0 1em'
        },
        '& th:last-child': {
            borderRadius: '0 1em 1em 0'
        }
    },
    businessType: {
        backgroundColor: "#78B1FE",
        color: "white",
        padding: "1px",
        borderRadius: theme.palette.borderRadius,
        textAlign: "center"
    },
    bottomTitle: {
        fontSize:"1.125rem",
        fontFamily: FontFamilySwitch().extraBold,

    },
    titleroot: {
        borderBottom: "1px solid #c1c1c1",
        marginBottom: "12px"
    },
    contentBottom: {},
    grid: {
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.palette.borderRadius,
        padding: "4px"
    },
    title: {
        fontSize:"0.875rem",
        fontFamily: FontFamilySwitch().bold,
        color: theme.typography.color.primary

    },
    subTitle: {
        fontSize:"0.75rem",
        fontFamily: FontFamilySwitch().semiBold,
        color: theme.palette.primary.main
    },
    divider: {
        height: "12px",
        width: "2px",
        backgroundColor: "black"
    }
}))

export const AddAmenitiesPopupStyle = makeStyles((theme) => ({
    header: {
        fontSize:"0.75rem",
        color: theme.typography.color.primary,
        fontWeight: "bold"
    },
    slot_textbox: {
        height: 22,
        width: 112,
        marginTop: 5
    },
    day: {
        color: theme.typography.color.primary,
        border: `1px solid ${theme.palette.border.secondary}`,
        borderRadius: 20,
        height: 42,
        width: 60,
        fontSize:"0.75rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor:"pointer"
    },
    highlight_day: {
        color: theme.palette.primary.main,
        background: theme.palette.info.light,
        border: `1px solid ${theme.palette.primary.main}`,
        borderRadius: 20,
        height: 42,
        width: 60,
        fontSize:"0.75rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor:"pointer"
    },
    day_text: {
        fontSize:"0.75rem"
    },
    ex_selected: {
        height: 15,
        width: 15,
        borderRadius: 4,
        border: `1px solid ${theme.palette.primary.main}`,
        background: theme.palette.info.light,
    },
    ex_auto_select: {
        height: 15,
        width: 15,
        borderRadius: 4,
        background: theme.palette.info.light,
    },
    desclimer: {
        fontSize:"0.75rem",
        color: theme.typography.color.Tertiary
    },
    selected: {
        borderRadius: 4,
        border: `1px solid ${theme.palette.primary.main}`,
        background: theme.palette.info.light,
        textAlign: "center",
        margin: 4,
        fontSize: "0.75rem",
        fontWeight: "bold",
        padding: "10px 6px",
        color: theme.palette.primary.main,
        cursor:"pointer"
    },
    auto_selected: {
        borderRadius: 4,
        background: theme.palette.info.light,
        textAlign: "center",
        margin: 4,
        fontSize:"0.75rem",
        fontWeight: "bold",
        padding: "10px 6px",
        color: theme.typography.color.Tertiary
    },
    body: {
        height: "380px",
        overflow: "auto"
    },
    not_selected: {
        borderRadius: 4,
        border: `1px solid ${theme.palette.border.secondary}`,
        backgroundColor: "transparent",
        textAlign: "center",
        margin: 4,
        fontSize:"0.75rem",
        fontWeight: "bold",
        padding: "10px 6px",
        color: theme.typography.color.primary,
        cursor:"pointer"
    }
}))